import { render } from "./WorkflowGoals.vue?vue&type=template&id=6d952e4e"
import script from "./WorkflowGoals.vue?vue&type=script&lang=js"
export * from "./WorkflowGoals.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__